module.exports = __webpack_public_path__ + "img/1 (28).bcfedf73.png";